import { authClient } from './client';
import extractErrorMessage from '../utils/extractErrorMessage';

const scheduledNotificationApi = {
  getAll: async (page = 1, limit = 10) => {
    try {
      return (await authClient.get('/scheduled-notifications', { params: { page, limit } })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  getById: async (id) => {
    try {
      return (await authClient.get(`/scheduled-notifications/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  create: async (data) => {
    try {
      return (await authClient.post('/scheduled-notifications', data)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  update: async (id, data) => {
    try {
      return (await authClient.put(`/scheduled-notifications/${id}`, data)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  toggleActive: async (id, status) => {
    try {
      return (await authClient.patch(`/scheduled-notifications/${id}/toggle`, { status })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  remove: async (id) => {
    try {
      return (await authClient.delete(`/scheduled-notifications/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },
};

export default scheduledNotificationApi;
